import { Image } from '@change/ds-core-ui/next';

import { PageBanner } from '../PageBody/components/PageBanner';

import { PageHeaderTitle } from './components/PageHeaderTitle';
import { PageHeaderToolbar } from './components/PageHeaderToolbar';
import { usePageHeader } from './hooks/usePageHeader';

export function PageHeader(): JSX.Element {
	const { data } = usePageHeader();

	return (
		<>
			<PageBanner />
			<header className={data.headerStyle} aria-label="Starter Dashboard page header" data-testid="page-header">
				<div data-testid="page-header-container" className={data.containerStyle}>
					<PageHeaderTitle
						image={
							data.imageUrl && (
								<Image
									alt={data.title}
									data-testid="starter-dashboard-header-image"
									data-qa="starter-dashboard-header-image"
									src={data.imageUrl}
									className="rounded-medium flex aspect-square h-[40px] w-[40px] flex-shrink-0 items-center justify-center object-cover"
								/>
							)
						}
						title={data.title}
					/>
					{data.actionButtons.length > 0 && (
						<PageHeaderToolbar
							actionButtons={data.actionButtons}
							actionButtonsOrientation={data.actionButtonsOrientation}
							mobile={data.mobile}
						/>
					)}
				</div>
			</header>
		</>
	);
}
